import src from "./instyle.svg";
export default { src: src, aspect: 4.25531914893617, width: 200, height: 47 };